/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppStatic from "../../utils/AppStatic";
import AppButton from "../button/AppButton";
import LazyVideo from "../video/video";
import {
    PiArrowBendLeftDownLight
} from "react-icons/pi";
import {FaShoppingBag} from "react-icons/fa";
import {BsChatRightDots} from "react-icons/bs";

const AppIVYPlanner = () => {
    return (
        <>
            <div className="relative text-black">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-center">
                    <div className="relative flex justify-center rounded-xl app-video order-2 md:order-1">
                        <LazyVideo
                            className="w-full md:w-75p h-full min-h-auto lg:min-h-[500px]"
                            src="/clips/ivy/ivy-intro.mp4"
                            muted={true} loop={true} controls={false} autoPlay={true}></LazyVideo>
                    </div>
                    <div className="order-1 md:order-2">
                        <h3 className="text-4xl font-bold md:text-6xl mb-2">{AppStatic.ivyPlannerHeading.ro.translation}</h3>
                        <p className="mb-2 font-thin tracking-wider">{AppStatic.ivyPlannerDescription.ro.translation}</p>
                        <p className="mb-6 font-bold ">{AppStatic.ivyPlannerHook.ro.translation}</p>
                        <div
                            className="mb-6 text-3xl md:text-4xl lg:text-6xl mt-4 font-bold uppercase">
                            <p>{AppStatic.ivyPlannerHashtagFirst.ro.translation}</p>
                            <p>{AppStatic.ivyPlannerHashtagSecond.ro.translation}</p>
                            <p>{AppStatic.ivyPlannerHashtagThird.ro.translation}</p>
                        </div>
                        <div className="mt-8 mb-10 flex flex-wrap gap-2">
                            <AppButton data={{
                                action: "scroll",
                                id: "app-plans",
                                name: AppStatic.mainBuyCta.ro.translation,
                                icon: <FaShoppingBag className="f-2"/>,
                                extraClass: "border-white!",
                            }}/>
                            <AppButton data={{
                                action: "scroll",
                                id: "app-plans",
                                name: AppStatic.mainTryIVY.ro.translation,
                                icon: <BsChatRightDots className="f-2"/>,
                                extraClass: "bg-white! text-black! border-black!",
                            }}/>
                        </div>
                        <div
                            className="font-thin text-xs text-black italic mb-8">*{AppStatic.ivyDisclaimer.ro.translation}</div>
                    </div>
                </div>
                <div className="pt-10 flex text-sm gap-2 justify-center items-center">
                    <PiArrowBendLeftDownLight/> {AppStatic.appViewPlacementBlock.ro.translation}
                </div>
            </div>
        </>
    );
}

export default AppIVYPlanner;
